/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const da_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const de_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const en_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const es_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const fr_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const hu_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const it_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const nl_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const pl_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const pt_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

const sv_regions_us_maryland3 = /** @type {(inputs: {}) => string} */ () => {
	return `Maryland`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const regions_us_maryland3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.regions_us_maryland3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("regions_us_maryland3", locale)
	if (locale === "cs") return cs_regions_us_maryland3(inputs)
	if (locale === "da") return da_regions_us_maryland3(inputs)
	if (locale === "de") return de_regions_us_maryland3(inputs)
	if (locale === "en") return en_regions_us_maryland3(inputs)
	if (locale === "es") return es_regions_us_maryland3(inputs)
	if (locale === "fr") return fr_regions_us_maryland3(inputs)
	if (locale === "hu") return hu_regions_us_maryland3(inputs)
	if (locale === "it") return it_regions_us_maryland3(inputs)
	if (locale === "nl") return nl_regions_us_maryland3(inputs)
	if (locale === "pl") return pl_regions_us_maryland3(inputs)
	if (locale === "pt") return pt_regions_us_maryland3(inputs)
	return sv_regions_us_maryland3(inputs)
};
export { regions_us_maryland3 as "regions.US.Maryland" }